// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2BW6E","vLegacy":"SelectSecondary_vLegacy__ifsnA","error":"SelectSecondary_error__hIUzr","disabled":"SelectSecondary_disabled__2FZew"};